module.exports = __webpack_public_path__ + "static/media/anon_avatar_yellow.d22e23ff.svg";